import { render } from "./TutorialPage.vue?vue&type=template&id=23ae49ec&scoped=true"
import script from "./TutorialPage.vue?vue&type=script&lang=js"
export * from "./TutorialPage.vue?vue&type=script&lang=js"

import "./TutorialPage.vue?vue&type=style&index=0&id=23ae49ec&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ae49ec"]])

export default __exports__